module.exports = __webpack_public_path__ + "media/images/Laurie-f0505be8237c41beeced584ced23db1b.jpg";